<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M3.5 3.5L20.5 20.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
  <path
    d="M9.2 9.45C8.45 10.2 8 11.2 8 12.35C8 14.55 9.79 16.35 12 16.35C13.15 16.35 14.15 15.9 14.9 15.15"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
  />
  <path
    d="M6.2 6.75C4.55 8.05 3.2 9.95 2.5 12C2.5 12 5.5 17.5 12 17.5C13.55 17.5 14.95 17.1 16.15 16.45"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
  />
  <path
    d="M10.5 7.05C10.95 6.95 11.45 6.9 12 6.9C18.5 6.9 21.5 12.4 21.5 12.4C21.5 12.4 20.45 14.35 18.55 15.95"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
  />
</svg>
